import request from '../utils/request';

// 分页查询商品评论
export function pageGoodsComments(page, pageSize, queryParams) {
  return request({
    url: '/goods-comment/page',
    method: 'get',
    params: {
      page,
      pageSize,
      ...queryParams
    }
  });
}